import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://3fc29262d424f1ea454cf702319e9511@o4507469287718912.ingest.de.sentry.io/4509240466997328',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0, // Adjust for performance
    environment: import.meta.env.MODE, // Vite's env variable
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    release: import.meta.env.VITE_APP_VERSION, // Optional: Add version in vite.config.ts
  });
};
